import { Action, createReducer, on } from '@ngrx/store';
import { of } from 'rxjs';
import * as fromPaymentsAndStatementsActions from '../actions';
import { AddedPaymentMethod, PaymentMethod } from '../dto/payment-method.dto';

export const paymentMethodFeatureKey = 'paymentMethod';

export interface State {
  loaded: boolean;
  error?: Error | any;
  paymentMethods: AddedPaymentMethod[];
}

export const initialState: State = {
  loaded: false,
  error: undefined,
  paymentMethods: undefined
};

export const reducer = createReducer(
  initialState,
  on(fromPaymentsAndStatementsActions.loadPaymentMethods, state => state),
  on(fromPaymentsAndStatementsActions.loadPaymentMethodsSuccess, (state, action) => ({
    ...state,
    paymentMethods: action.response,
    loaded: true
  })),
  on(fromPaymentsAndStatementsActions.loadPaymentMethodsFailure, (state, { error }) => ({
    ...state,
    error
  }))
);

export const selectPaymentMethods = (state: State) => {
  let newArr;
  newArr = state.paymentMethods;

  if (state.paymentMethods !== undefined) {
    newArr = state.paymentMethods.filter(card => card.details !== 'Wallet');
  }

  return newArr;
};

export const selectPaymentMethodsLoaded = (state: State) => state.loaded;
export const selectPaymentMethodsError = (state: State) => state.error;
